function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "BackArrow_svg__a",
  d: "M14.273 4.351l-12.068.041L5.7 1.079a.626.626 0 00-.863-.908l-4.639 4.4a.625.625 0 000 .912l4.669 4.366a.626.626 0 00.854-.915L2.206 5.646l12.068-.041a.626.626 0 000-1.252z"
});

function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.899 10.017"
  }, props), _ref, _ref2);
}

export default SvgBackArrow;